import { render, staticRenderFns } from "./LiveClass.vue?vue&type=template&id=a6cbe6b8&scoped=true&"
import script from "./LiveClass.vue?vue&type=script&lang=js&"
export * from "./LiveClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cbe6b8",
  null
  
)

export default component.exports